import { render, staticRenderFns } from "./ViewFilesHome.vue?vue&type=template&id=d24122b2&"
import script from "./ViewFilesHome.vue?vue&type=script&lang=js&"
export * from "./ViewFilesHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports